import React from 'react';
import { string, bool, number, func, shape } from 'prop-types';
import classnames from 'classnames';
import { productShape } from 'shapes';
import { WishlistButton, AddToCartButton } from './components';
import './ActionBlock.scss';

export default function ActionBlock({
    className,
    product,
    isB2B,
    dataPosition,
    dataSponsored,
    onAddToCartClick,
    onWishListClick,
    showWishListButton,
    isInWishList,
    unableRedirectToModels,
}) {
    const rootClassnames = classnames('action-block', className);

    return (
        <div className={rootClassnames}>
            {showWishListButton && (
                <div className="action-block__wishlist">
                    <WishlistButton
                        className="action-block__wishlist__icon"
                        active={isInWishList}
                        product={product}
                        onClick={onWishListClick}
                        isB2B={isB2B}
                    />
                </div>
            )}
            <AddToCartButton
                product={product}
                isB2B={isB2B}
                dataPosition={dataPosition}
                dataSponsored={dataSponsored}
                onClick={onAddToCartClick}
                unableRedirectToModels={unableRedirectToModels}
            />
        </div>
    );
}

ActionBlock.propTypes = {
    className: string,
    product: productShape.isRequired,
    isB2B: bool,
    dataPosition: number,
    dataSponsored: shape({
        status: bool,
        id: string,
    }),
    onAddToCartClick: func,
    onWishListClick: func,
    showWishListButton: bool,
    isInWishList: bool,
    unableRedirectToModels: bool,
};

ActionBlock.defaultProps = {
    className: null,
    isB2B: false,
    dataPosition: null,
    dataSponsored: {
        status: false,
        id: undefined,
    },
    onAddToCartClick: null,
    onWishListClick: null,
    showWishListButton: false,
    isInWishList: false,
    unableRedirectToModels: false,
};
